@if (banners) {
  <ngb-carousel [showNavigationArrows]="showNavigationArrows" [showNavigationIndicators]="showNavigationIndicators">
    @for (banner of banners; track banner) {
      <ng-template ngbSlide>
        <div class="tw-w-full tw-max-h-[calc(100vh-1px)] tw-flex tw-items-center tw-justify-center">
          <img [src]="banner" alt="Random slide" class="tw-object-contain tw-w-full tw-h-full tw-rounded-lg" />
        </div>
      </ng-template>
    }
  </ngb-carousel>
}
